// Testimonials for MenoMatch
export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    age: 52,
    location: "California",
    text: "This quiz helped me find the perfect supplement combination for my symptoms. Within 3 weeks, my hot flashes reduced by 80% and I'm finally sleeping through the night again!",
    rating: 5,
    symptoms: ["Hot Flashes", "Sleep Issues"],
    initials: "SM",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&crop=faces"
  },
  {
    id: 2,
    name: "Jennifer K.",
    age: 48,
    location: "Texas",
    text: "I was skeptical at first, but the personalized recommendations were spot-on. My energy levels are back, and I feel like myself again. Thank you, MenoMatch!",
    rating: 5,
    symptoms: ["Fatigue", "Mood Swings"],
    initials: "JK",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop&crop=faces"
  },
  {
    id: 3,
    name: "Linda R.",
    age: 55,
    location: "Florida",
    text: "After struggling with menopause symptoms for years, this quiz finally pointed me in the right direction. The natural supplements work better than I expected!",
    rating: 5,
    symptoms: ["Hot Flashes", "Joint Pain"],
    initials: "LR",
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=400&fit=crop&crop=faces"
  },
  {
    id: 4,
    name: "Patricia D.",
    age: 50,
    location: "New York",
    text: "The quiz was so easy and the recommendations were incredibly helpful. I love that everything is natural and backed by science. Highly recommend!",
    rating: 5,
    symptoms: ["Anxiety", "Brain Fog"],
    initials: "PD",
    image: "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=400&h=400&fit=crop&crop=faces"
  },
  {
    id: 5,
    name: "Michelle T.",
    age: 49,
    location: "Oregon",
    text: "Finally, a resource that understands what I'm going through! The personalized approach made all the difference. I've already recommended this to all my friends.",
    rating: 5,
    symptoms: ["Weight Gain", "Sleep"],
    initials: "MT",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=faces"
  },
  {
    id: 6,
    name: "Karen S.",
    age: 53,
    location: "Arizona",
    text: "I wish I had found MenoMatch sooner! The supplements they recommended have been life-changing. My mood is stable and my hot flashes are almost gone.",
    rating: 5,
    symptoms: ["Mood Changes", "Hot Flashes"],
    initials: "KS",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop&crop=faces"
  }
];

export default testimonials;




